import { defineAsyncComponent } from 'vue'
export default {
  alumni: defineAsyncComponent(() => import("/opt/render/project/src/layouts/alumni.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/render/project/src/layouts/default.vue").then(m => m.default || m))
}